import {
  Table,
  Button,
  Collapse,
  Tag,
  Upload,
  Form,
  DatePicker,
  Row,
  Col,
  Select,
  message,
  Popconfirm,
  Input,
} from "antd/lib";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  EyeOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  DownloadOutlined,
  UploadOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  FileDoneOutlined,
  CheckCircleOutlined,
  SyncOutlined,
  SearchOutlined,
  RedoOutlined,
} from "@ant-design/icons";
import { SingleQuote, GetQuotes } from "../../Redux/actions/NumBikeation";
import moment from "moment";
import Remarks from "./RemarkForm";
import { PaymentLinkPosp } from "./paymentLink";
// import SearchFormPosp from './PospSearchForm';

export default function MyPolicyDetail() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const [Cform] = Form.useForm();
  const paymentBtnRef = useRef(null);
  const { RangePicker } = DatePicker;
  const PospNum = useSelector((state) => state?.posp?.Posp);
  const ViewSingleQuote = useSelector((state) => state?.posp?.PospViewQuote);
  const MakeData = useSelector((state) => state?.vehicledetail?.bikeMakeData);
  const [RcfileList, setRcfileList] = useState([]);
  const [PolicyfileList, setPolicyfileList] = useState([]);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [SendLoading, setSendLoading] = useState(false);
  const [EditDocLoad, setEditDocLoad] = useState(false);
  const [EditdRc, setEditdRc] = useState(false);
  const [EditPolPdf, setEditPolPdf] = useState(false);
  const [ViewQuote, setViewQuote] = useState(false);
  const { Panel } = Collapse;
  const [activeKey, setActiveKey] = useState(["1", "2", "4", "5"]);
  const [refreshload, setRefreshload] = useState(false);
  const [fuelType, setFuelType] = useState("");
  const [resendQuote, setresendQuote] = useState(
    ViewSingleQuote?.is_acknowledgement_sent === true
  );
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
  useEffect(() => {
    if (ViewQuote && paymentBtnRef.current) {
      paymentBtnRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [ViewQuote, resendQuote]);

  useEffect(() => {
    const inputString = MakeData?.customized_variant;
    const match = inputString?.match(/\(([^)]+)\)$/);
    if (match) {
      const result = match[1];
      console.log(result);
      if (result === "P") {
        setFuelType("PETROL");
      } else if (result === "D") {
        setFuelType("DIESEL");
      } else if (result === "E") {
        setFuelType("ELECTRIC");
      } else if (result === "BATTERY") {
        setFuelType("BATTERY");
      }
    } else {
      console.log("No match found.");
    }
  }, [ViewSingleQuote]);

  const showPopconfirm = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      const response = await axiosInPosp.get(
        `v1/posp/quick_quotes?page=${page}`
      );
      const { data } = response;
      console.log(data);
      setData(data?.data);
      setLoading(false);
      setPagination({
        ...pagination,
        current: data.current_page,
        total: data.total,
      });
    } catch (error) {
      console.log(error.response.data);
      setLoading(false);
      if (error?.response?.data?.message === "Unauthenticated.") {
        message.error(error?.response?.data?.message + "Login again");
        dispatch((dispatch) => {
          dispatch({ type: "RESET_STATE" });
          dispatch({ type: "LOGOUT_POSP" });
        });
        history.push("/");
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleTableChange = (pagination) => {
    console.log(pagination);
    fetchData(pagination.current);
  };

  const props1 = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setRcfileList([...RcfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = RcfileList.indexOf(file);
      const newFileList = RcfileList.slice();
      newFileList.splice(index, 1);
      setRcfileList(newFileList);
    },
    RcfileList,
  };
  const props2 = {
    multiple: false,
    accept: "application/pdf",
    beforeUpload: (file) => {
      setPolicyfileList([...PolicyfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = PolicyfileList.indexOf(file);
      const newFileList = PolicyfileList.slice();
      newFileList.splice(index, 1);
      setPolicyfileList(newFileList);
    },
    PolicyfileList,
  };
  const EditRc = () => {
    setEditdRc(!EditdRc);
    setEditPolPdf(false);
  };
  const EditPolicy = () => {
    setEditPolPdf(!EditPolPdf);
    setEditdRc(false);
  };
  const onChange = (keys) => {
    console.log(keys);
    setActiveKey(keys);
  };

  const handlePanel1Click = () => {
    setActiveKey(activeKey.length === 0 ? ["1", "2", "3", "4", "5"] : []);
  };

  const columns = [
    {
      title: "Quote No",
      dataIndex: "quick_quote_number",
      width: "15%",
      sorter: {
        compare: (a, b) => {
          return a.quick_quote_number.localeCompare(b.quick_quote_number);
        },
      },
    },
    {
      title: "Customer Name",
      dataIndex: "firstName",
      sorter: {
        compare: (a, b) => {
          return a.firstName.localeCompare(b.firstName);
        },
      },
    },
    {
      title: "Registration Number",
      dataIndex: "licensePlateNumber",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Creation Date",
      dataIndex: "created_at",
      sorter: {
        compare: (a, b) => {
          return a.created_at.localeCompare(b.created_at);
        },
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "15%",
      render: (_, record) => (
        <span>
          {record?.status === "Reject" ? (
            <Tag color="#cd201f">Rejected</Tag>
          ) : record?.status === "Quote pending" ? (
            <Tag color="#87d068">Quote Pending</Tag>
          ) : record?.status === "Document clarification" ? (
            <Tag
              color="#FFD681"
              className="tag-posp"
              icon={<ExclamationCircleOutlined />}
            >
              Document clarification
            </Tag>
          ) : record?.status === "Payment done" ? (
            <Tag
              color="#00b600"
              className="tag-posp"
              icon={<CheckCircleOutlined />}
            >
              Payment done
            </Tag>
          ) : record?.status === "Proceed for payment" ? (
            <Tag
              color="#1890FF"
              className="tag-posp"
              icon={<SyncOutlined spin />}
            >
              Proceed for payment
            </Tag>
          ) : record?.status === "Payment link pending" ? (
            <Tag color="#108ee9">Payment link pending</Tag>
          ) : record?.status === "Pdf generated" ? (
            <Tag
              color="#00b600"
              className="tag-posp"
              icon={<FileDoneOutlined />}
            >
              Pdf generated
            </Tag>
          ) : record?.status === "Quote generated" ? (
            <Tag
              color="#00b600"
              className="tag-bpo"
              icon={<FileDoneOutlined />}
            >
              Quote generated
            </Tag>
          ) : record?.status === "Completed" ? (
            <Tag
              color="#00b600"
              className="tag-bpo"
              icon={<CheckCircleOutlined />}
            >
              Completed
            </Tag>
          ) : (
            ""
          )}
        </span>
      ),
    },
    {
      title: "Action",
      key: "operation",
      render: (_, record) => (
        <span>
          <Button
            disabled={record?.status === "Reject"}
            onClick={() => handlerecord(record)}
            type="primary"
            shape="circle"
            value="small"
            icon={<EyeOutlined />}
          />
        </span>
      ),
    },
  ];
  const handlerecord = (record) => {
    setLoading(true);
    console.log(record);
    const config = {
      headers: {
        Authorization: "Bearer " + PospNum?.accessToken,
      },
    };
    axiosInPosp
      .get(`v1/posp/quick_quotes/${record.id}`, config)
      .then((res) => {
        console.log(res);
        let singData = res?.data;
        console.log(singData);
        dispatch(SingleQuote(singData));
        setLoading(false);
        setViewQuote(true);
      })
      .catch((err) => {
        console.log(err.response.data);
        if (err?.response?.data.message === "Unauthenticated.") {
          dispatch((dispatch) => {
            dispatch({ type: "RESET_STATE" });
            dispatch({ type: "LOGOUT_POSP" });
          });
          history.push("/");
        }
        setLoading(true);
      });
  };
  const BacktoTable = () => {
    setViewQuote(false);
    setEditdRc(false);
    setEditPolPdf(false);
    // history.push('/PospMenu')
    dispatch(SingleQuote(""));
    fetchData();
  };
  const confirm = (e) => {
    console.log(e);
    setConfirmLoading(true);
    const numValue = Cform.getFieldValue("MobileNumber");
    console.log(numValue);
    console.log(typeof numValue);
    const config = {
      headers: {
        Authorization: "Bearer " + PospNum.accessToken,
        "Content-Type": "application/json",
      },
    };
    const post = {
      mobile: numValue,
    };
    axios
      .post(
        `${BASEURL}v1/posp/quick_quotes/${e?.quick_quote_id}/acknowledgement`,
        post,
        config
      )
      .then((res) => {
        console.log(res);
        let singData = res?.data?.data;
        console.log(singData);
        setSendLoading(false);
        dispatch(SingleQuote(singData));
        setOpen(false);
        setConfirmLoading(false);
        message.success("Message Send");
      })
      .catch((err) => {
        console.log(err);
        setConfirmLoading(false);
        setSendLoading(false);
      });
  };
  const SendQuoteToCustomer = (reply) => {
    setSendLoading(true);
    console.log(reply);
    const config = {
      headers: {
        Authorization: "Bearer " + PospNum.token,
      },
    };
    axiosInPosp
      .post(
        `v1/posp/quick_quotes/${reply?.quick_quote_id}/acknowledgement`,
        config
      )
      .then((res) => {
        console.log(res);
        let singData = res?.data?.data;
        console.log(singData);
        setSendLoading(false);
        dispatch(SingleQuote(singData));
      })
      .catch((err) => {
        console.log(err);
        setSendLoading(false);
      });
  };
  const onRcSubmit = () => {
    console.log(RcfileList);
    setEditDocLoad(true);
    const formData = new FormData();
    formData.append("_method", "PUT");
    formData.append("rc_copy", RcfileList[0]);
    axiosInPosp
      .post(`v1/posp/quick_quotes/${ViewSingleQuote.id}`, formData)
      .then((res) => {
        console.log(res);
        let updateQuote = res?.data?.data;
        console.log(updateQuote);
        dispatch(SingleQuote(updateQuote));
        setEditDocLoad(false);
        setRcfileList([]);
        setEditdRc(false);
        dispatch(GetQuotes());
        //setViewQuote(false)
      })
      .catch((err) => {
        console.log(err);
        setEditDocLoad(false);
      });
  };
  const onPolicySubmit = () => {
    console.log(PolicyfileList);
    setEditDocLoad(true);
    const formData = new FormData();
    formData.append("_method", "PUT");
    formData.append("policy_copy", PolicyfileList[0]);
    axiosInPosp
      .post(`v1/posp/quick_quotes/${ViewSingleQuote.id}`, formData)
      .then((res) => {
        console.log(res);
        let updateQuote = res?.data?.data;
        console.log(updateQuote);
        dispatch(SingleQuote(updateQuote));
        setPolicyfileList([]);
        setEditPolPdf(false);
        setEditDocLoad(false);
        dispatch(GetQuotes());
      })
      .catch((err) => {
        console.log(err);
        setEditDocLoad(false);
      });
  };
  const RefreshForm = () => {
    setRefreshload(true);
    setLoading(true);
    form.resetFields();
    setTimeout(() => {
      setRefreshload(false);
      setLoading(false);
      fetchData();
      dispatch(GetQuotes());
    }, 1000);
  };
  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      console.log("From: ", dates[0], ", to: ", dates[1]);
      console.log("From: ", dateStrings[0], ", to: ", dateStrings[1]);
    } else {
      console.log("Clear");
      form.resetFields();
      fetchData();
    }
  };
  const onFinish = (values) => {
    values.start_date = moment(values?.date_range[0]).format("MM-DD-YYYY");
    values.end_date = moment(values?.date_range[1]).format("MM-DD-YYYY");
    console.log(values);
    setLoading(true);
    axiosInPosp
      .get(
        `v1/posp/quick_quotes?page=1&per_page=10&filters[product_type]=${values.product_name}`
      )
      .then((res) => {
        const { data } = res;
        console.log(data);
        setData(data?.data);
        setLoading(false);
        setPagination({
          ...pagination,
          current: data.current_page,
          total: data.total,
        });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  return (
    <div style={{ padding: 20 }}>
      {ViewQuote === true ? (
        <>
          <div className="colpse-posp-sec" ref={paymentBtnRef}>
            {ViewSingleQuote?.status === "Reject" ? (
              <div className="reject-txt">
                *Quote Rejected
                <p>{ViewSingleQuote?.remarks}</p>
              </div>
            ) : null}
            {ViewSingleQuote?.payment_link ? (
              <div className="payment-btn">
                <a href={ViewSingleQuote?.payment_link} target="_blank">
                  PAYMENT LINK
                </a>
              </div>
            ) : null}
            <div className="posp-bck-inner">
              <div onClick={BacktoTable} className="posp-bck-menu">
                Back
              </div>
              <span onClick={handlePanel1Click} className="po-collapse-icn">
                {activeKey.length > 0 ? (
                  <MinusCircleOutlined />
                ) : (
                  <PlusCircleOutlined />
                )}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6 col-lg-6 px-3 col-md-6">
              <Collapse
                className="posp-collapse"
                activeKey={activeKey}
                onChange={onChange}
              >
                <Panel header="BASIC DETAILS" key="1" className="posp-pannel">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Quote Number</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.quick_quote_number}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Creation Date</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.created_at}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Product Name</div>
                      <div className="w-50 text-end">Two Wheeler</div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Product Type</div>
                      <div className="w-50 text-end">Comprehensive</div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Required Policy Type</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.required_policy_type}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Required Insurer</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.required_insurers
                          ?.map((insurance, i) => ({
                            key: i + 1,
                            value: insurance,
                            label: insurance,
                          }))
                          .map((mappedInsurance, i) => (
                            <div key={i + 1}>{mappedInsurance.label}</div>
                          ))}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Customer Type</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.policyHolderType}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Name</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.firstName} {ViewSingleQuote?.lastName}
                      </div>
                    </div>
                    {/* <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Mobile</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.MobileNumber}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Email</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.email}
                      </div>
                    </div> */}
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Address</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.address}
                      </div>
                    </div>
                    {/* <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Aadhaar No</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.aadhaar_number}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">PAN No</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.PAN_Number}
                      </div>
                    </div> */}
                  </div>
                </Panel>
                {/* <Panel header="NOMINEE DETAILS" key="5" className="posp-pannel">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Nominee Name</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.Nname}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Nominee DOB</div>
                      <div className="w-50 text-end">
                        {moment(ViewSingleQuote?.Ndob).format("DD-MM-YYYY")}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Nominee Relationship</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.Nrelation}
                      </div>
                    </div>
                  </div>
                </Panel> */}
              </Collapse>
            </div>
            <div className="col-xl-6 col-lg-6 px-3 col-md-6">
              <Collapse
                className="posp-collapse"
                activeKey={activeKey}
                onChange={onChange}
              >
                <Panel header="VEHICLE DETAILS" key="2" className="posp-pannel">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Make</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.make}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Model & Varient</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.model} {ViewSingleQuote?.variant}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Fuel Type</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.fuel_type}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Registration Year</div>
                      <div className="w-50 text-end">
                        {moment(ViewSingleQuote?.registrationDate).format(
                          "DD-MM-YYYY"
                        )}
                      </div>
                    </div>
                    {ViewSingleQuote?.seat_capacity ? (
                      <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                        <div className="w-50">Seating Capacity</div>
                        <div className="w-50 text-end">
                          {ViewSingleQuote?.seat_capacity}
                        </div>
                      </div>
                    ) : null}
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Engine Number</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.Engine}
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Chasis Number</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.Chasis}
                      </div>
                    </div>
                  </div>
                </Panel>
                {ViewSingleQuote?.addons ? (
                  <Panel header="ADDONS" key="3" className="posp-pannel">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 bpo-inner-pannel">
                      <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                        <div className="w-50">Addons</div>
                        <div className="w-50 text-end">
                          {ViewSingleQuote?.addons
                            ?.map((insurance, i) => ({
                              key: i + 1,
                              value: insurance,
                              label: insurance,
                            }))
                            .map((mappedInsurance, i) => (
                              <div key={i + 1}>{mappedInsurance.label}</div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </Panel>
                ) : null}
                <Panel
                  header="Additional Covers"
                  key="4"
                  className="posp-pannel"
                >
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 bpo-inner-pannel">
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Additional Covers</div>
                      <div className="w-50 text-end">
                        {ViewSingleQuote?.additional_covers
                          ?.map((insurance, i) => ({
                            key: i + 1,
                            value: insurance,
                            label: insurance,
                          }))
                          .map((mappedInsurance, i) => (
                            <div key={i + 1}>{mappedInsurance.label}</div>
                          ))}
                      </div>
                    </div>
                  </div>
                </Panel>
                <Panel
                  header="DOCUMENT DETAILS"
                  key="5"
                  className="posp-pannel"
                >
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">RC Copy</div>
                      <div className="w-50 text-end d-flex justiy-content-end doc-edit">
                        <a
                          href={ViewSingleQuote?.rc_copy}
                          download
                          target="_blank"
                        >
                          View
                        </a>
                        <a onClick={EditRc}>Edit</a>
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Previous Policy Copy</div>
                      <div className="w-50 text-end text-end d-flex justiy-content-end doc-edit">
                        <a
                          href={ViewSingleQuote?.policy_copy}
                          download
                          target="_blank"
                        >
                          View
                        </a>
                        <a onClick={EditPolicy}>Edit</a>
                      </div>
                    </div>
                    {EditdRc === true ? (
                      <div className="py-2">
                        <div className="upd-rc-sec">Update RC Copy</div>
                        <div className="w-100 d-flex align-items-center justify-content-center p-2">
                          <div className="w-50">
                            <Upload {...props1} maxCount={1}>
                              <Button
                                type="primary"
                                className="upload-btn"
                                icon={<UploadOutlined />}
                              >
                                Upload
                              </Button>
                            </Upload>
                          </div>
                          <div className="w-50 text-end d-flex justiy-content-end doc-edit">
                            <Button
                              type="primary"
                              loading={EditDocLoad}
                              className="upload-btn"
                              onClick={onRcSubmit}
                            >
                              Update
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {EditPolPdf === true ? (
                      <div className="py-2">
                        <div className="upd-rc-sec">Update Previous Policy</div>
                        <div className="w-100 d-flex align-items-center justify-content-center p-2">
                          <div className="w-50">
                            <Upload {...props2} maxCount={1}>
                              <Button
                                type="primary"
                                className="upload-btn"
                                icon={<UploadOutlined />}
                              >
                                Upload
                              </Button>
                            </Upload>
                          </div>
                          <div className="w-50 text-end d-flex justiy-content-end doc-edit">
                            <Button
                              type="primary"
                              className="upload-btn"
                              onClick={onPolicySubmit}
                            >
                              Update
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Aadhaar Copy</div>
                      <div className="w-50 text-end">
                        <a
                          href={ViewSingleQuote?.aadhaar_copy}
                          download
                          target="_blank"
                        >
                          View
                        </a>
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                      <div className="w-50">Pancard Copy</div>
                      <div className="w-50 text-end">
                        <a
                          href={ViewSingleQuote?.pancard_copy}
                          download
                          target="_blank"
                        >
                          View
                        </a>
                      </div>
                    </div>
                  </div>
                </Panel>
              </Collapse>
              {ViewSingleQuote?.replies?.length > 0 ? (
                <>
                  {ViewSingleQuote?.replies.map((reply, index) => (
                    <div
                      key={reply.id}
                      className="d-flex justify-content-between mb-2"
                    >
                      <Button
                        type="primary"
                        className="pdf-btn"
                        icon={<DownloadOutlined />}
                      >
                        <a href={reply?.attachment} target="_blank">
                          View Quote ({index + 1}){" "}
                        </a>
                      </Button>
                      {index === 0 && (
                        <div className="d-flex flex-column position-relative align-items-center">
                          {/* <Button
                            type="primary"
                            className="pdf-btn"
                            loading={SendLoading}
                            onClick={() => {
                              SendQuoteToCustomer(reply);
                            }}
                            disabled={resendQuote}
                          >
                            Send To Customer
                          </Button> */}
                          <Popconfirm
                            placement="left"
                            title={
                              <Form form={Cform} layout="vertical">
                                <Form.Item
                                  name="MobileNumber"
                                  label="Mobile Number"
                                >
                                  <Input
                                    type="number"
                                    placeholder="Enter Mobile Number"
                                  />
                                </Form.Item>
                              </Form>
                            }
                            okText="Send"
                            open={open}
                            onConfirm={() => {
                              confirm(reply);
                            }}
                            //onConfirm={handleOk}
                            okButtonProps={{
                              loading: confirmLoading,
                            }}
                            onCancel={handleCancel}
                          >
                            <Button
                              type="primary"
                              onClick={showPopconfirm}
                              disabled={resendQuote}
                            >
                              Send To Customer
                            </Button>
                          </Popconfirm>
                          {ViewSingleQuote?.is_acknowledgement_sent === true ? (
                            <a
                              className="resend-q"
                              onClick={() => {
                                setresendQuote(false);
                              }}
                            >
                              Resend Quote ?
                            </a>
                          ) : null}
                        </div>
                      )}
                    </div>
                  ))}
                </>
              ) : null}
            </div>
            <div className="row">
              <div className="col-xl-6 col-lg-6 px-3 col-md-6">
                <Remarks />
              </div>
              {ViewSingleQuote?.payment_link ? (
                <div className="col-xl-6 col-lg-6 px-3 col-md-6">
                  <PaymentLinkPosp />
                </div>
              ) : null}
            </div>
          </div>
        </>
      ) : (
        <>
          {/* <SearchFormPosp setLoading={setLoading}/> */}
          <Form
            form={form}
            style={{ width: "100%" }}
            requiredMark={false}
            layout="vertical"
            onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
          >
            <div className="row align-items-center px-3">
              <div className="col-xl-3 col-lg-3 col-sm-12">
                <Form.Item
                  label="Product Name"
                  name="product_name"
                  rules={[
                    {
                      required: true,
                      message: "Please select DOB",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    //defaultValue="TWO WHEELER"
                    placeholder="Select a Product"
                    optionFilterProp="children"
                    // onChange={onChangeProduct}
                    // onSearch={onSearch}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        value: "PRIVATE CAR",
                        label: "PRIVATE CAR",
                      },
                      {
                        value: "TWO WHEELER",
                        label: "TWO WHEELER",
                      },
                      {
                        value: "PASSENGER CARRYING",
                        label: "PASSENGER CARRYING",
                      },
                      {
                        value: "GOODS CARRYING",
                        label: "GOODS CARRYING",
                      },
                      {
                        value: "HEALTH",
                        label: "HEALTH",
                      },
                    ]}
                  />
                </Form.Item>
              </div>
              <div className="col-xl-3 col-lg-3 col-sm-12">
                <Form.Item
                  name="date_range"
                  label="Date"
                  rules={[
                    {
                      required: true,
                      message: "Please select Date",
                    },
                  ]}
                >
                  <RangePicker onChange={onRangeChange} />
                </Form.Item>
              </div>
              <div className="col-xl-3 col-lg-3 col-sm-12">
                <Form.Item className="mb-0 text-center">
                  <div className="btn-group row">
                    <Button
                      className="search-btn col-xl-4 col-lg-4 col-sm-12"
                      type="primary"
                      htmlType="submit"
                      // loading={loading}
                      icon={<SearchOutlined />}
                    >
                      Search
                    </Button>
                    <Button
                      className="refresh-btn col-xl-4 col-lg-4 col-sm-12"
                      type="primary"
                      loading={refreshload}
                      onClick={RefreshForm}
                      icon={<RedoOutlined />}
                    >
                      Refresh
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </div>
          </Form>
          <Table
            className="posp-table"
            pagination={pagination}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={data}
            loading={loading}
            onChange={handleTableChange}
          />
        </>
      )}
    </div>
  );
}
